import { ArticleModuleHeroSidebarSection } from '#components/Article/Modules/ArticleModuleHeroSidebarSection';
import { getCopyrightInformation } from '#cutils/articles/getCopyrightInformation';
import { MediaContextPlaybackStatus } from '#cutils/context/MediaContext';

import styles from './ArticleModuleHeroSidebarSectionCopyright.module.scss';
import type { ArticleModuleHeroSidebarSectionCopyrightFragment } from './__generated__/ArticleModuleHeroSidebarSectionCopyright.generated';

type Props = {
	teaserModule: ArticleModuleHeroSidebarSectionCopyrightFragment;
	mediaPlaybackStatus: MediaContextPlaybackStatus;
};

export function ArticleModuleHeroSidebarSectionCopyright({ teaserModule, mediaPlaybackStatus }: Props) {
	const { copyright, text, thumbnailCopyright, thumbnailText } = getCopyrightInformation(teaserModule);

	const isPlayingOrPaused =
		mediaPlaybackStatus === MediaContextPlaybackStatus.PAUSED || mediaPlaybackStatus === MediaContextPlaybackStatus.STARTED;

	const title = isPlayingOrPaused ? 'Media' : 'Bild';

	if (!title) {
		return null;
	}

	const imageCopyright = thumbnailCopyright ? `Bildrechte: ${thumbnailCopyright}` : null;
	const avCopyright = copyright ? `© ${copyright}` : null;

	const setCopyright = isPlayingOrPaused ? avCopyright : imageCopyright;
	const setText = isPlayingOrPaused ? text : thumbnailText;

	return (
		<ArticleModuleHeroSidebarSection className="body3" title={title}>
			{text && <div className={styles.part}>{setText}</div>}

			{copyright && <div className={styles.part}>{setCopyright}</div>}
		</ArticleModuleHeroSidebarSection>
	);
}
